import { useState, useEffect } from 'react';

const navItems = [
  { label: '首页', href: '#hero' },
  { label: '话题热议', href: '#topics' },
  { label: '常见问答', href: '#faq' },
  { label: '观众热评', href: '#comments' },
  { label: '专题索引', href: '#index' },
  { label: '精选推荐', href: '#cards' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    setMobileOpen(false);
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-20">
          <a
            href="#hero"
            onClick={(e) => handleNavClick(e, '#hero')}
            className="flex items-center gap-2 cursor-pointer"
          >
            <span className="font-heading text-2xl md:text-3xl text-primary-500 whitespace-nowrap">
              51影视
            </span>
          </a>

          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => handleNavClick(e, item.href)}
                className="px-3 py-2 text-sm text-foreground-700 hover:text-primary-500 transition-colors rounded-md whitespace-nowrap cursor-pointer"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 cursor-pointer"
            aria-label="菜单"
          >
            <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <nav className="md:hidden bg-background-50 border-t border-background-200/70 px-4 py-3">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={(e) => handleNavClick(e, item.href)}
              className="block py-3 px-3 text-sm text-foreground-700 hover:text-primary-500 hover:bg-background-100 rounded-md transition-colors cursor-pointer"
            >
              {item.label}
            </a>
          ))}
        </nav>
      )}
    </header>
  );
}